import subscription from '../../api/admin.js'
const state = {
    color: "",
    status: 0,
    dueMessage: ""
};
const getters = {
    getColor(state) {
        return state.color;
    },
    getStatus(state) {
        return state.status;
    },
    getDueMessage(state) {
        return state.dueMessage;
    },
};
const mutations = {
    UPDATE_SUB_STATUS(state, subscription) {
        state.color = subscription.color;
        state.status = subscription.status;
        state.dueMessage = subscription.dueMessage;
    },
    CLEAR_SUB_STATUS(state) {
        state.color = "";
        state.status = 0;
        state.dueMessage = "";
    }

};
const actions = {
    async getSubscriptionStatus({ commit }) {
        try {
            let response = await subscription.getSubscriptionDetail("AGPLMS");
            commit('CLEAR_SUB_STATUS');
            if (response && response.data && response.data.resultType == 200 && response.data.payload) {
                let date1 = new Date(response.data.payload.paymentDueDate);
                let date2 = new Date();
                date2.setHours(0);
                let secs = parseInt((date2.getTime() - date1.getTime()) / 1000);
                let days = Math.floor(secs / (60 * 60 * 24));
             
                if (days < 0 && days >= response.data.payload.startUiDisplay) {
                    commit('UPDATE_SUB_STATUS', { color: "warning", status: 1, dueMessage: `Your subscription to the API  is due to expire in ${-days} days. We kindly request that you renew your subscription to avoid disruption.` });
                }
                if (days >= 0) {
                    commit('UPDATE_SUB_STATUS', { color: "error", status: 2, dueMessage: `To ensure uninterrupted platform access, please renew your subscription to the API, as it has expired on ${date1.toLocaleDateString()} and usage will be disabled thereafter.` });
                }
                if (days >= 0 && days >= response.data.payload.stopUiDisplay) {
                    commit('UPDATE_SUB_STATUS', { color: "error", status: 3, dueMessage: `To ensure uninterrupted platform access, please renew your subscription to the API, as it has expired on  ${date1.toLocaleDateString()} and usage has been disabled thereafter.` });
                }
            }
            if(!response){
                commit('UPDATE_SUB_STATUS', { color: "error", status: 4, dueMessage: `There has been issue, please contact admin for support.` });
            }
        } catch (error) {
           
            commit('UPDATE_SUB_STATUS', { color: "error", status: 3, dueMessage: `There has been issue, please contact admin for support.` });
        }

    },
    clearSubStatus({ commit }) {
        commit('CLEAR_SUB_STATUS')
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}